import { Component, Inject, OnInit, inject, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { FormGroup, FormBuilder, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { TeamService } from '../../../services/team.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NonActiveWorkDialogComponent } from '../non-active-work-dialog/non-active-work-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { ModelVariant } from '../../../../shared/models/type-list';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-rename-variant',
  imports: [CommonModule, MatDialogModule, ReactiveFormsModule, FormsModule, MatChipsModule, MatFormFieldModule, MatIconModule, MatAutocompleteModule,
    MatProgressSpinner, MatSelectModule, MatInputModule, MatButtonModule, MatDialogModule, MatListModule, MatTooltipModule],
  templateUrl: './rename-variant.component.html',
  styleUrl: './rename-variant.component.scss',
  standalone: true
})
export class RenameVariantComponent implements OnInit {
  protected svc_Team = inject(TeamService);

  @ViewChild('renameInput', {static: true}) renameElement!: ElementRef<HTMLInputElement>;

  fg_RenameVariant: FormGroup=<FormGroup>{};

  variantName: string = '';
  prvVariantName: string = '';
  variantStatus: string = '';
  variantMsg: string = '';

  isBusy: boolean = false;

  model_variants: ModelVariant[] = [];
  
constructor(
    public dialogRef: MatDialogRef<RenameVariantComponent>,
    @Inject(MAT_DIALOG_DATA) public inData: any,
    private fb: FormBuilder,
    private dialog: MatDialog
  ){}

  
  
  ngOnInit(): void {
    console.log(this.inData)
    this.model_variants = this.inData.model_variants ? this.inData.model_variants : [];
    this.variantName = this.inData.variant_name? this.inData.variant_name: '';
    this.prvVariantName = this.inData.variant_name? this.inData.variant_name: '';
    this.variantMsg = this.inData.variant_msg? this.inData.variant_msg: '';
    this.variantStatus = this.inData.variant_status? this.inData.variant_status: '';

    this.fg_RenameVariant = this.fb.group({
      f_VariantName: [(this.variantName == null)? '': this.variantName, Validators.required]
    });

    this.fg_RenameVariant.valueChanges.subscribe((formValues) =>{
      this.variantName = formValues.f_VariantName;
    });

    this.dialogRef.afterOpened().subscribe(() => {
      this.selectAndFocusInput();
    })
  }

  get modelNamesText(): string {
    if(this.model_variants?.length === 1){
      return `Variant ${this.prvVariantName} contains model: ${this.model_variants?.map(model => model.model_name).join(', ')}`
    } else if (this.model_variants?.length > 1){
      return `Variant ${this.prvVariantName} contains models:\n${this.model_variants?.map(model => model.model_name).join('\n')}`
    }
    return '';
  }

  onSubmit(){
    this.isBusy = true;
    if (this.fg_RenameVariant.status == 'VALID'){
      this.svc_Team.updateTeamVariantName(this.inData.team_id, this.inData.variant_id, this.variantName).subscribe(out=>{
        this.isBusy = false;
        this.dialogRef.close({variant: {variant_name:this.variantName, variant_status: this.variantStatus, variant_msg: this.variantMsg}});
      })
    } else {
      this.isBusy = false;
      console.log('Form is invalid')
    }
  }

  onNoClick():void{
    this.dialogRef.close()
  }

  onReset():void{
    this.fg_RenameVariant.patchValue({
      f_VariantName: this.model_variants?.map(model => model.model_name).join('/') || ''
    });
  }

  private selectAndFocusInput() {
    console.log('Select and Focut Input')
    if (this.renameElement) {
      const nativeInput = this.renameElement.nativeElement;

      nativeInput.focus();
      nativeInput.setSelectionRange(0, nativeInput.value.length);
    }
  }

  onAssignNonActive(){
  const dialogRef = this.dialog.open(NonActiveWorkDialogComponent,{
        width: '600px',
        data: { team_id: this.inData.team_id, version_id: this.inData.version_id, variant_status: this.variantStatus, variant_msg: this.variantMsg }
      });
  
      dialogRef.afterClosed().subscribe(result =>{
        // add team variant to variant list
        console.log(result)
        if (result != undefined){
          if ( result.variant ){
            console.log(result.variant)
            this.variantStatus = result.variant.variant_status;
            this.variantMsg = result.variant.variant_msg;
          }
        }
      })
    }
}
